<template>
    <div class="form-group">
        <label :for="`${model.status.formId}_${name}`">{{label}}</label>
        <textarea :id="`${model.status.formId}_${name}`"
            :placeholder="placeholder"
            class="form-control"
            :name="name"
            :cols="cols"
            :rows="rows"
            v-model="model.vals[name]"
            :disabled="model.status.disabled || disabled"
            :required="required"
        ></textarea>
    </div>
</template>

<script>
export default {
    props:{
        name:String,
        label:String,
        model:Object,
        placeholder:{
            type:String,
            default:"",
        },
        cols:{
            type:String,
            default:"30",
        },
        rows:{
            type:String,
            default:"3",
        },
        disabled:{
            type:Boolean,
            default:false,
        },
        required:{
            type:Boolean,
            default:false
        },
    }

}
</script>

<style>

</style>
